export default "/assets/df6fa318539f8cc8.png"